import * as React from 'react';
import { useDispatch } from 'react-redux';
import { useDeviceType } from '@cian/ui-kit';
import { debounce } from 'throttle-debounce';

import { requestSuggestions, suggestionsReset } from '../../../actions/suggestions';
import { DEBOUNCE_DELAY } from '../../../constants/delays';
import { TThunkDispatch } from '../../../types/redux';
import { MIN_CHARS_TO_DISPLAY_SUGGEST } from '../constants';

export const useDebouncedValueEffect = (value: string, openSuggest: Function, closeSuggest: Function) => {
  const dispatch: TThunkDispatch = useDispatch();
  const deviceType = useDeviceType();

  const [isDebouncing, setIsDebouncing] = React.useState(false);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const requestSuggestionsDebounced = React.useCallback(
    debounce(DEBOUNCE_DELAY, (value: string) => {
      dispatch(requestSuggestions(value));
      setIsDebouncing(false);
    }),
    [dispatch],
  );

  React.useEffect(() => {
    if (deviceType === 'desktop') {
      if (value.length >= MIN_CHARS_TO_DISPLAY_SUGGEST) {
        setIsDebouncing(true);
        requestSuggestionsDebounced(value);
        openSuggest();
      } else {
        closeSuggest();
        dispatch(suggestionsReset());
      }
    }
  }, [deviceType, value, requestSuggestionsDebounced, openSuggest, closeSuggest, dispatch]);

  React.useEffect(() => {
    if (deviceType !== 'desktop') {
      if (value.length >= MIN_CHARS_TO_DISPLAY_SUGGEST) {
        setIsDebouncing(true);
        requestSuggestionsDebounced(value);
      } else {
        dispatch(suggestionsReset());
      }
    }
  }, [deviceType, value, requestSuggestionsDebounced, dispatch]);

  return isDebouncing;
};
